"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequirementDareMessages = void 0;
const useDareRequirementMessages_1 = require("root/src/client/logic/dropEvent/hooks/useDareRequirementMessages");
function RequirementDareMessages() {
    const daresMessages = (0, useDareRequirementMessages_1.useDareRequirementMessages)();
    return (<div className="m-[30px] text-center">
			{daresMessages.map(message => <p className="font-bold text-lg">{message}</p>)}
		</div>);
}
exports.RequirementDareMessages = RequirementDareMessages;
